import _ from 'lodash';
import { axiosInstance } from '../helpers/axios';
import { userService } from './user.service';

export const templateService = {
  create,
  findAll,
  findOne,
  update,
  findAllCategories,
  getStatistics,
  getResources,
};

function create(template) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: template,
  };

  return axiosInstance
    .post(`/templates`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .then(response => {
      return response;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findAll(query, publicRequest) {
  const url = publicRequest ? `/public/templates` : `/templates`;
  return axiosInstance
    .get(url, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findOne(id) {
  return axiosInstance
    .get(`/templates/${id}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function update({ id, ...template }) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: template,
  };

  return axiosInstance.put(`/templates/${id}`, requestOptions.body, requestOptions.headers).then(handleResponse);
}

function findAllCategories() {
  return axiosInstance
    .get(`/templateCategories`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function getStatistics(latest) {
  return axiosInstance
    .get(`/public/templates/statistics${latest ? '?latest=true' : ''}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function getResources(id) {
  return axiosInstance
    .get(`/templates/${id}/resources`)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
}

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }

  return data;
};
